// Projekt-Daten für die Tremoniacs-Website
// Jedes Projekt wird als Annotation im 3D-Raum platziert
// Texte übernommen aus der Original-Website (tremoniacs.xyz, WordPress)

const projectData = [
  {
    id: 'hildemaus',
    tags: ['game', 'installation'],
    isNew: true,
    name: 'Hildemaus',
    position: [0.5, 2.5, -1.2],
    shortInfo: 'Peppers-Ghost-Installation auf Basis eines 100 Jahre alten Poesiebuchs.',
    description: `Im Rahmen der "Lost & Found"-Ausstellung auf der uzwei im Dortmunder U entwickelte Timo die Peppers-Ghost-Installation zusammen mit der Schülerin Adelina Lavrentyev.

In Hildemaus taucht ihr in ein Poesiebuch ein, das die Mutter Anna vor über 100 Jahren für ihre Tochter Hildegard geschrieben hat. Im Buch wird Hildegard liebevoll mit Hildemaus angesprochen.

Als Tochter Hildegard durchläuft ihr in dieser Peppers-Ghost-Projektion die Seiten, die eure Mutter euch einst widmete, entdeckt vergessene Gedichte und reist durch diese verstaubte Mitschrift der Geschichte.

Eindrücke der Installation: instagram.com/uzwei.imdortmunderu/p/DB_Gkf5C63p

Mitwirkende: Timo Sodenkamp`,
    youtubeId: null,
    thumbnail: '/Hildemaus_Vorschau_e01.jpg',
    year: '2025',
  },
  {
    id: 'multiversurlaub',
    tags: ['musikvideo'],
    name: 'Multiversurlaub',
    position: [-1.8, -0.5, 2.2],
    shortInfo: 'Musikvideo von Andie & Roy — ein Trip durch die Dimensionen des Multiversums.',
    description: `"Multiversurlaub" ist das erste Musikvideo aus dem Album "Reudig an die Möllerbrücke 2" von Andie & Roy. Raum und Zeit wird auf dem Kopf gestellt, indem Roy Dik und Andie Möller durch viele unterschiedliche Dimensionen des Multiversums reisen. Sie erleben eine Odyssee durch fragmentierte Welten, in der die Grenzen zwischen Wahrnehmung und Realität verschwimmen.

Ein Urlaub zwischen Realitätsebenen

Nach einer durchgezechten Nacht von Andie & Roy öffnet sich ein Dimensionsriss, der sie in ein völlig neues Setting katapultiert: das Multiversum. Aber anstatt frustriert den Kopf in den Sand zu stecken, genießen Andie & Roy den Multiversurlaub. Roy Dik als sprintender Forrest Gump und im nächsten Shot als Karate Kid. Andie Möller unplugged und in Partyexstase in der alten Dortmunder Kneipe Rekorder.

Zwischen digitaler Ästhetik und surrealer Traumlogik

Visuell bewegt sich "Multiversurlaub" zwischen Retro-Computergrafik, 3D Visuals und glitchartiger Verzerrung. 3D Renderings kollidieren mit Deepfake Technologie und Videofootage während wir durch die einzelnen Realitäten von Roy Dik und Andie Möller reisen.

Realität als wandelbares Konstrukt

Am Ende bleibt die Frage: Would you like to book a trip to the multiversurlaub?

Mitwirkende: Laurin Bürmann, Timo Sodenkamp`,
    youtubeId: 'to2SKX_j86o',
    thumbnail: null,
    year: '2025',
  },
  {
    id: 'mapping-visuals',
    tags: ['mapping'],
    isNew: true,
    name: 'Mapping Live Performance',
    position: [3.0, -0.8, -0.5],
    shortInfo: 'Interaktive Live Performance mit Motion Capture beim Fassadenmapping am Dortmunder U.',
    description: `Bei dem Fassaden-/Projection-Mapping zur Museumsnacht 2025 des storyLab kiU haben wir vom Koproduktionslabor aus eine interaktive Live Performance mit Live Motion Capture, Unreal Engine, Max/MSP & Resolume gestaltet.

Den Prozess erklärt Timo auf Instagram: instagram.com/p/DP1EMo3Eh_5`,
    youtubeId: '2d-2ds7V8nk',
    thumbnail: null,
    year: '2025',
  },
  {
    id: 'cerm-suedsee',
    tags: ['musikvideo'],
    name: 'CERM – Südsee',
    position: [-0.8, 1.8, 1.8],
    shortInfo: 'Musikvideo im Look alter PS1-Spiele — Retro-Future trifft Sommer-Vibes.',
    description: `Für das Musikvideo zu "Südsee" gab es keine düsteren Gassen mit bedrohlich anmutenden Rappern im Strobolicht – stattdessen eine Reise durch Raum und Zeit. Mit einem Look aus alten PS1-Spiel Zeiten. Eine Welt, in der flimmernde Kanten, grobe Low-Poly-Modelle und knackscharfe 256x256-Texturen auf sommerlichen Vibes treffen.

Von der Südsee bis zum Mond – mit dem Cabrio durchs Universum

CERM und Smogylove brettern mit ihrem Cabrio nicht nur durch die Südsee, sondern quer durchs Universum. Mit dem Ziel, einen Sommerbanger auf dem Mond im durch Autobatterie betriebenen Popup-Studio aufzunehmen. Während die beiden durch die Galaxie fetzen, eine kleine Fehde mit einer frechen Taube austragen und zurück auf Tiny Planet Erde landen, flimmert das Bild wie in den guten alten Zeiten der ersten 3D-Konsolen.

Zurück auf der Erde wird der Sommer-Sonne-Strand-Track mit ein paar NPCs zelebriert – zwischen Pixel-Palmen, Low-Res-Wellen und ordentlich Bass.

Retro-Future trifft Sommer-Vibes

Mit CERM – Südsee haben wir ein Musikvideo als Hommage an das Gaming der 90er geschaffen. Nostalgie trifft auf Science-Fiction, Rap auf Retro-Ästhetik.

Mitwirkende: Timo Sodenkamp, Laurin Bürmann`,
    youtubeId: 'EhPs_Yd_MfE',
    thumbnail: null,
    year: '2024',
  },
  {
    id: 'new-now',
    tags: ['installation'],
    name: 'New Now',
    position: [1.5, 3.0, 0.3],
    shortInfo: '10-stündiger künstlerischer Livestream beim New Now Festival 2023.',
    description: `Beim New Now Festival 2023 wurde digitale Kunst nicht nur diskutiert, sondern direkt transformiert. Im Rahmen des Festivals realisierten wir einen 10-stündigen künstlerischen Livestream, der weit über eine klassische Übertragung hinausging – ein visuelles Experiment, das den Festival-Feed mit einer kreativen Ebene verschmolz und die Grenzen zwischen Realität und digitaler Manipulation auflöste.

Hypernatural Forces – Digitale Kunst in Echtzeit dekonstruiert

Unter dem Festivalmotto "Hypernatural Forces" wurde erforscht, welche Kräfte Digitalität und Natur verbindet. Diese Idee spiegelte sich direkt im Livestream wider: 3D-Scans der Speaker wurden live in den Feed integriert – digitale Avatare, die mit der realen Bühne verschmolzen. Blender-Animationen reagierten in Echtzeit auf das Bühnengeschehen. Namen und Titel der Speaker wurden direkt in 3D editiert und interaktiv ins Kamerabild eingefügt. Der Live-Kamerafeed wurde über Resolume verfremdet – Farben veränderten sich, 3D-Visuals erschienen, AI-generierte Bilder entwickelten sich on the fly.

Jede Diskussion, jede Bewegung auf der Bühne hatte eine visuelle Entsprechung, die sich ständig wandelte. Der Stream wurde in Echtzeit neu inszeniert.

10 Stunden visuelle Evolution

Über die Dauer des Streams entstanden verschiedene visuelle Etappen, die sich an den inhaltlichen Themen orientierten. Mal war der Feed minimalistisch, mal visuell überladen. Mal dominierte abstrakte Verfremdung, mal hyperrealistische Simulation. Es war ein Stream, der nicht dokumentierte, sondern interpretierte.

Das New Now Festival versteht sich als Schnittstelle zwischen Kunst und Technologie – unser Livestream wurde zu einem Teil dieser künstlerischen Forschung.

Mitwirkende: Laurin Bürmann, Timo Sodenkamp`,
    youtubeId: 'X_NKUqz6a7s',
    thumbnail: null,
    year: '2023',
  },
  {
    id: 'der-sog',
    tags: ['musikvideo'],
    name: 'Der Sog',
    position: [-2.0, 2.8, -0.8],
    shortInfo: '3D-Kurzfilm über die Dortmunder Nordstadt während der Pandemie.',
    description: `"Der Sog" ist ein 3D-Kurzfilm, den Timo Ende 2021 abgeschlossen hat. Die fiktive Welt besteht aus vielen Fassaden der Dortmunder Nordstadt, die zu dieser Zeit Timos neuer Wohnort während der Corona-Pandemie wurde, welche zu einem neu kontextualisierten Schauplatz werden.

Der knapp 2 Minuten lange Stummfilm greift die gesellschaftliche Dichotomie und die Rolle der Kunst innerhalb dieser auf. Er ist eine Ode an die Musik und ihre transzendentale Kraft, die in diesem dystopisch anmutenden Milieu nicht zur freien Entfaltung kommt.

Mitwirkende: Timo Sodenkamp`,
    youtubeId: 'j7wKz6McYaY',
    thumbnail: null,
    year: '2021',
  },
  {
    id: 'more-many',
    tags: ['mapping'],
    name: 'More Many',
    position: [2.8, 2.0, 1.0],
    shortInfo: 'Projection Mapping in der Zeche Westerholt — Bilder von Many Szejstecki erweckt zum Leben.',
    description: `Mit More Many wurde 2024 ein außergewöhnliches Projection Mapping in der Zeche Westerholt realisiert – eine visuelle und akustische Erfahrung, die Vergangenheit, Gegenwart und digitale Ästhetik miteinander verwebt.

Das Künstlerkollektiv aus den 3D-Artists Azziza El Yabadri, Laurin Bürmann, Timo Sodenkamp und Lennart Oberscheidt sowie dem Sounddesigner Michael Nguyen erweckte die Bilder von Many Szejstecki zum Leben. Seine Werke, die sich mit den Tiefen des Ruhrgebiets auseinandersetzen, wurden in einen digitalen Kunstfilm transformiert, der die Unternehmerkaue der Zeche Westerholt in eine Projektionsfläche verwandelte.

Der Waschraum der Zeche – 35 Meter tief, 10 Meter breit und 10 Meter hoch – wurde vollständig bespielt: Wände, Boden und Raumstruktur verschmolzen mit den Projektionen und erzeugten eine Immersive Experience.

Die Reise beginnt mit der Fahrt in einen dunklen Schacht – ein Übergang in eine Welt aus netzartigen, abstrakten Strukturen, die an die mathematischen Zeichnungen von Szejstecki erinnern. Seine Ästhetik, geprägt von präzisen Linien und Formen, erinnert an die Struktur von 3D-Polygonen und war die Grundlage für die Transformation ins Digitale.

Während der achtminütigen Projektion entstehen und zerfallen virtuelle Landschaften: Der Boden beginnt zu bröckeln, Wände reißen auf, Gesteinsschichten schieben sich übereinander. Tunnel und Schächte öffnen sich, als würde man sich durch das Erdreich bewegen. Am Ende erreicht man eine organische, fast mythische Landschaft – ein Ort, der trotz der Eingriffe der Bergleute überdauert hat.

Digitale Kunst als Echo der Vergangenheit

More Many verbindet die industrielle Vergangenheit des Ruhrgebiets mit den Möglichkeiten der digitalen Kunst. Zeichnung und 3D-Animation, Realität und Simulation, Geschichte und Gegenwart fließen ineinander.

Mitwirkende: Laurin Bürmann, Timo Sodenkamp, Azziza El Yabadri, Lennart Oberscheidt, Michael Nguyen`,
    youtubeId: 'Kwp6gpZoifE',
    thumbnail: null,
    year: '2024',
  },
  {
    id: 'yes-ai-can',
    tags: ['installation'],
    name: 'Yes AI Can',
    position: [-1.2, 0.0, -1.8],
    shortInfo: 'Keyvisual für das Kunstfestival Yes AI Can — über KI, Wahrheit und Wahrnehmung.',
    description: `Für das Rostocker Kunstfestival Yes AI Can entwickelte Laurin mit der Dortmunder Agentur Die Transformer ein Keyvisual, das die Vielfalt künstlicher Intelligenz und ihre ästhetischen Strömungen in den Fokus rückt. Doch es ging um mehr als nur visuelle Spielerei. Das Projekt stellte eine tiefere Frage: Wie verändert KI unseren Blick auf Wahrheit, Identität und Schöpfung?

Die rote Mütze – Symbol für Medien, Manipulation und Realität

Im Zentrum der Visuals steht eine rote Mütze – ein bewusst gewähltes Symbol, das sich auf Fake News und die Problematik der medialen Wahrnehmung bezieht. In einer Zeit, in der KI immer glaubhafter Bilder und Informationen generiert, müssen wir unsere Wahrnehmung schärfen: Was ist real? Was ist konstruiert? Und wer entscheidet darüber?

Kollision von KI, Menschheit und Mythologie

Für die Visuals wurde eine Kombination aus AI-generierten Bildern und 3D-Visuals geschaffen. Dabei durchläuft die rote Mütze eine Reihe von Transformationen: Sie dehnt sich, verflüssigt sich, explodiert. Sie wird fragmentiert, verzerrt und neu zusammengesetzt. Sie interagiert mit rasant geschnittenen Bildern von Maya-Stämmen, der Geburt eines Menschen und christlichen Schöpfungssymbolen. Diese Gegenüberstellung stellt eine Verbindung zwischen KI und den Mythen menschlicher Schöpfung her.

Ein 15-Sekunden-Manifest der Veränderung

Das Ergebnis ist ein 15-sekündiger Trailer, der die rote Mütze als rotierendes Symbol des Wandels zeigt. Sie durchläuft unzählige Zustände, verliert sich, formt sich neu – ein Sinnbild für die sich ständig verändernde Debatte um KI, Wahrheit und unsere eigene Wahrnehmung.

Mitwirkende: Laurin Bürmann`,
    youtubeId: null,
    thumbnail: '/YES_AI_CAN_Vorschau.jpg',
    year: '2023',
  },
  {
    id: 'dortmund-dance-division',
    tags: ['mapping'],
    name: 'Dortmund Dance Division',
    position: [0.2, -1.0, 2.5],
    shortInfo: 'Live Visuals für ein Techno-Event im Langen August, Dortmund.',
    description: `Für ein Techno-Event der Dortmund Dance Division im Langen August, einem autonomen Zentrum in der Dortmunder Nordstadt, haben Azziza El-Yabadri, Timo Sodenkamp, Laurin Bürmann, Flor de Fuego und Lennart Oberscheidt Live Visuals inszeniert, die sich zwischen Brutalismus, digitaler Ästhetik und organischen Strukturen bewegt.

In einer Reihe von dystopischen Visuals wurden Kontraste zwischen Vergangenheit, Gegenwart und Zukunft erzählt: Klapphandys in endlosen, liminalen Räumen – verloren zwischen Nostalgie und futuristischer Isolation. Riesige Bagger, die Steine zertrümmern als Sinnbild für den unaufhaltsamen Eingriff des Menschen in die Natur und Raumkapseln, die durch das schwarze Nichts treiben.

Zusätzlich wurden AI-generierte Bilder in Szene gesetzt und mit den Creative-Coding-Visuals von Flor de Fuego kombiniert. Die organisch verzerrten Formen der KI trafen auf den algorithmisch generierten Code.

Die Visuals wurden in Resolume arrangiert und auf zwei verschiedene Projektionsflächen geworfen – eine vor den DJs, eine hinter ihnen. So entstand eine immersive Umgebung, in der sich Musik, Bild und Raum gegenseitig verstärkten.

Mitwirkende: Azziza El-Yabadri, Timo Sodenkamp, Laurin Bürmann, Flor de Fuego, Lennart Oberscheidt`,
    youtubeId: null,
    thumbnail: '/DDD_Greifarm0.jpg',
    year: '2023',
  },
  {
    id: 'its-not-a-game',
    tags: ['game'],
    name: "It's not a game",
    position: [-2.8, 1.5, -1.5],
    shortInfo: 'Der Kulturort Rekorder als begehbares 3D-Modell und VR-Reflexion über Entscheidungsfreiheit.',
    description: `Was bleibt von einem Ort, wenn er nicht mehr physisch existiert? Wir haben den Kulturort Rekorder in Dortmund kurz vor seiner Schließung gescannt und als detailgetreues 3D-Modell nachgebaut – inklusive Kratzer, Graffitis und durchgesessenen Sessel. Mithilfe der Unreal Engine haben wir Licht, Atmosphäre und Interaktivität rekonstruiert. Eine Original-Soundaufnahme des letzten Kneipenabends hallt durch die Kopfhörer: Man kann den Raum frei erkunden, Objekte anfassen, sich umsehen – als hätte der Rekorder nie geschlossen.

Vom digitalen Archiv zur interaktiven Erfahrung

Bei der ersten Ausstellung (Tremoniacs – Visual Overload) war der VR-Rekorder noch ein begehbares Erinnerungsstück. Doch in der zweiten Version wurde er zur interaktiven Reflexion über Entscheidungsfreiheit.

Sobald man den virtuellen Raum betritt, diskutieren gottähnliche Stimmen über einen selbst: Wird man heute trinken oder widerstehen? Folgt man den Stimmen, erreicht man das "Ende" des Spiels – man hat der Versuchung standgehalten. Ignoriert man sie, beginnt die Realität zu kippen: Die Sicht verschwimmt. Ein gigantisches Wesen reißt das Dach auf und spricht auf einen ein. Oder der Kühlschrank entwickelt ein Eigenleben und verlässt den Raum.

"The 'It's not a game' Game" ist mehr als eine digitale Rekonstruktion – es ist ein Experiment mit Wahrnehmung und Entscheidungen. Der Rekorder existiert weiter, aber nicht nur als VR-Modell, sondern als Ort, an dem Realität und Virtualität ineinanderfließen.

To be continued.

Mitwirkende: Timo Sodenkamp, Laurin Bürmann`,
    youtubeId: null,
    thumbnail: '/REK_Zoom_In0.jpg',
    year: '2022',
  },
  {
    id: 'mapping-2021',
    tags: ['mapping'],
    name: 'Mapping 2021',
    position: [1.0, 0.5, -2.0],
    shortInfo: 'Projection Mapping »What is Europe?« am Dortmunder U zur Museumsnacht 2021.',
    description: `Das 3D-Projektionsmapping »What is Europe?« beleuchtet die Entstehungsgeschichte Europas in Form eines 8-minütigen audiovisuellen Erlebnisses auf der Süd- und Westfassade des Dortmunder U zur Dortmunder DEW21-Museumsnacht 2021.

Die spektakuläre Kunstperformance schlägt das Buch der europäischen Geschichte in dreidimensionaler Form auf und nimmt die Zuschauer*innen mit auf eine rasante und mysteriöse Reise zu den Eckpunkten eines sich stetig verändernden Kontinentes und seiner Bevölkerung. Unter Berücksichtigung der Frage, was oder wer Europa ist, war und sein wird, entwickelt sich das Dortmunder U zu einem dynamischen Rubiks-Cube. Als dieser sich mit salzigem Wasser füllt und damit die Thematik des Mittelmeeres als Fluchtroute aufgreift, wird dem Publikum ein riesiger Spiegel vorgehalten. Vielstimmig ruft es »What is Europe?«.

Perspektivisch an den Betrachter*innen-Standpunkt vor der Süd-West-Fassade angepasst, verändert sich das U-Gebäude zu einer dreidimensionalen Struktur, wobei das Spiel mit den Höhen und Tiefen das Gebäude zum Leben erweckt und das Dortmunder U zum Sprechen bringt. Der Sound wird aus verschiedenen Richtungen über die gesamte Fassade verteilt abgespielt und mündet in einem immersiven Klangerlebnis.

Laurin und Timo erarbeiteten mehrere Szenen des Projection Mappings inklusive Erstellung der Assets, Animation und Rendering.

Mitwirkende: Timo Sodenkamp, Laurin Bürmann, storyLab kiU`,
    youtubeId: 'KG7czrIBTJY',
    thumbnail: null,
    year: '2021',
  },
  {
    id: 'mapping-2023',
    tags: ['mapping'],
    name: 'Mapping 2023',
    position: [-2.2, -0.8, 0.5],
    shortInfo: 'Audioreaktives Projection Mapping »What is Human?« am Dortmunder U, 2023.',
    description: `Für die Museumsnacht 2023 arbeitete Laurin Bürmann als Teil des Koproduktionslabors mit den Musiker*innen Present Paradox, Jani und EEPH, um ein audioreaktives Fassaden-Mapping zu kreieren. In diesem Jahr war das Thema des Projection Mappings Künstliche Intelligenz, unter der Frage "What is Human?".

Künstliche Intelligenzen sind größtenteils "Black Boxen", die Teile unseres Lebens automatisieren, ohne dass wir – als Gesellschaft – vollends verstehen, wie sie funktionieren. Eine der Kernfragen drehte sich darum, ob und wenn ja inwieweit Künstliche Intelligenz menschliches Fühlen imitieren oder sogar erleben kann. Inwieweit sind die heutigen Künstlichen Intelligenzen ein Spiegelbild des Menschen und was lernen wir durch sie, um uns der Beantwortung der Frage "What is Human?" zu nähern.

In diesem Zusammenhang erarbeitete Laurin Bürmann mit den Musiker*innen ein audiovisuelles Liveset. Die Musiker selektierten zur Thematik passende Musikstücke, welche vom Team des Labors visuell untermalt wurden. Die Stimmung des Stücks und das Thema Künstliche Intelligenz wurden in abstrakten Bildern aufgegriffen, welche zum Teil selbst von einer Bildgenerierungs-KI erschaffen wurden.

Mit einer Standbilder-Sammlung der letzten Projection Mappings am Dortmunder U trainierte er ein eigenes Stable-Diffusion-Model, um damit KI-generierte Bilder zu erzeugen. Weitere Visuals wurden mit Cinema 4D gerendert, in dem die MoGraph-Effektoren und das Plug-In X-Particles für abstrakte Animationen genutzt wurden.

Die Form, Farbe und Geschwindigkeit der Visuals passte sich dem musikalischen Rhythmus an und wurde mit Visuals aus Max/MSP Jitter in Resolume Arena gemixt. Die Max/MSP-Visuals und deren Live-Ausspielung wurden von Fabian Bentrup vom storyLab kiU übernommen. Hierdurch entstand ein Live-Zusammenspiel von zwei Visual Artists, die ihre visuelle Interpretation der Musik inszenierten. Die Fassade schien eins zu werden mit der Performance der Musiker.

Mitwirkende: Laurin Bürmann, EEPH, Jani, Present Paradox, storyLab kiU`,
    youtubeId: 'rRG8UknVzbA',
    thumbnail: null,
    year: '2023',
  },
  {
    id: 'ineverfinishanyth',
    tags: ['game'],
    name: 'i never finish anyth',
    position: [-0.5, -0.2, -2.5],
    shortInfo: 'Mystery Adventure Puzzle Game — Timos Bachelor-Abschlussprojekt.',
    description: `Das Mystery Adventure Puzzle Game ist Timos Bachelor-Abschlussprojekt.

Darin stellt der Hauptcharakter nach und nach fest, dass er lediglich der digitale Scan eines prokrastinierenden Studenten ist – und nun in dessen angefangenem, aber nie fertiggestelltem Projekt feststeckt. Die Spielwelt wirkt daher teils unfertig und löst sich an ihren Rändern in Partikel auf. Die Zeit steht still, und Kommiliton*innen sind in natürlichen Posen eingefroren.

Besonders spannend dabei war die Digitalisierung realer Orte und der damit einhergehende Prozess der Fragmentierung, Optimierung und anschließenden Re-Konstruktion vertrauter Räume, aus denen sich Emotionen und Erfahrungen aus dem Analogen ableiten lassen, die dann wiederum mit der virtuellen Wahrnehmung verschmelzen.

Mitwirkende: Timo Sodenkamp`,
    youtubeId: 'c60C6pfyolk',
    thumbnail: null,
    year: '2023',
  },
  {
    id: '17-semester',
    tags: ['musikvideo'],
    name: '17. Semester',
    position: [2.5, 3.2, -0.3],
    shortInfo: 'Musikvideo von Andie & Roy — ein wilder Ritt durchs Dortmunder Studentenleben.',
    description: `Das Musikvideo "17. Semester" von Andie & Roy ist ein wilder Ritt durch das Dortmund Studentenleben. Timo und Laurin aka Andie & Roy haben für dieses Video 3D Scans von sich selbst erstellt und in Blender und Cinema 4D in 3D Szenen aus ikonischen Dortmund Orten integriert. Im Video fliegen diese Avatare über die Stadt, tanzen als Riesen im Westpark und transformieren sich zu einem Tesla, um davon zu düsen.

Diese Kombination aus Musik und Animation ermöglicht es Timo & Laurin, ihre künstlerischen Fähigkeiten aus beiden Bereichen zu vereinen. Und dieses Video war der Startschuss.

Mitwirkende: Timo Sodenkamp, Laurin Bürmann`,
    youtubeId: 'hCKvXWwOyTk',
    thumbnail: null,
    year: '2021',
  },
  {
    id: 'heilig-x-mapping',
    tags: ['mapping'],
    isNew: true,
    name: 'Heilig X Mapping',
    position: [-1.5, -1.3, -0.5],
    shortInfo: 'ExtraSicht 👀 — filmisches Manifest über die spekulative Zukunft des Ruhrgebiets.',
    description: `ExtraSicht 👀

Die spektakuläre und spekulative Zukunft des Ruhrgebiets

Für das Quartier Bochumer Straße und das gesamte Ruhrgebiet gibt es kein Zurück mehr in das montanindustrielle Zeitalter – und doch ist das Erbe der Gründerjahre unser stärkster Motor. Unter dem Motto „Standing on the shoulders of giants" knüpft dieser Film an den Wagemut der historischen Gründerpersönlichkeiten an. Wir lassen uns von der Entschlossenheit eines Friedrich Grillo, August Thyssen und Hugo Stinnes inspirieren, um eine Transformation zu entwerfen, die das Revier heute zukunftsfit macht. Zur Extraschicht wagen wir eine Extra-Sicht 👀 und setzen zum großen künstlerischen Sprung an. Wir spekulieren über eine Zukunft, in der das Ruhrgebiet in 100 oder 500 Jahren als utopisches Kraftzentrum neu erstrahlt. Wie sähe eine Welt aus, die den Geist der alten Gründer mit den technologischen und ökologischen Möglichkeiten von morgen verschmilzt? Es entsteht ein filmisches Manifest für eine Region, die sich gerade zum zweiten Mal neu erfindet – spektakulär, spekulativ und zutiefst mutig.`,
    youtubeId: '18EbBo2zrgc',
    thumbnail: '/HKK_Vorschau_e05_1.jpg',
    year: '2025',
  },
]

export default projectData
